export default __webpack_public_path__ + "static/media/insta17.c5b7e979.webp";